import { IBaseModel } from 'src/model/BaseModel';

import { toApi } from './utils';

export default (data: any, Model: IBaseModel) => {
  return JSON.stringify(toApi(data, Model.toApi));
};
